import React from 'react';
import SalaryDownload from '../components/SalaryDownload';

const EmployeeSalaryPage = () => {
    return <SalaryDownload />;
};

export default EmployeeSalaryPage;
